export default __webpack_public_path__ + "assets/images/c1037ccf999b5f7430dd7f457daa3469.png";